import { Ability } from '@casl/ability'
import { initialAbility } from './config'
import { getUserData } from '@/auth/utils';
// Récupère les données utilisateur depuis localStorage
//const userDataString = getJsonFromStorage('userData');
let userData = getUserData
// // Vérifie si les données existent et les analyse
// if (userDataString) {
//   try {
//     userData = JSON.parse(userDataString);
//   } catch (error) {
//     console.error('Failed to parse userData from localStorage:', error, 'userDataString:', userDataString);
//   }
// }

// Récupère les capacités existantes de l'utilisateur ou utilise les capacités initiales
const existingAbility = userData ? userData.ability : null;

// Exporte une nouvelle instance de Ability avec les capacités existantes ou initiales
export default new Ability(existingAbility || initialAbility);
